<template>
    <span v-if="mostrarIcone">
        <span class="text-primary ml-1">
            <i
                class="fa fa-pie-chart fa-lg icon-button"
                title="Rateio"
                @click.stop="toRateio()"
            ></i>
        </span>
    </span>
</template>

<script>
export default {
    props: {
        etapa: {
            type: Object,
            default: () => ({})
        },

        rotaRateio: {
            type: String
        },

        permiteAcesso: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {}
    },

    methods: {
        toRateio() {
            this.$router.push({
                name: this.rotaRateio,
                params: {
                    etapaId: this.etapa.etapaId
                }
            })
        }
    },

    computed: {
        mostrarIcone() {
            return (
                this.permiteAcesso &&
                this.etapa.responsavelComprometimento == 'SEF'
            )
        }
    }
}
</script>
